module.exports = __webpack_public_path__ + "static/media/circulo_BC8268.776244e5.svg";